/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(function($){
  $.fn.extend({
    // ページ内スクロール
    pageScroll:function(options){
      var defaults={
        speed:400
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      $t.on('click',function(){
        var Hash=$(this.hash);
        if($(Hash).length){
          var HashOffset=$(Hash).offset().top-$('#section-header').innerHeight()
          $('html:not(:animated),body:not(:animated)').animate({ scrollTop:HashOffset+'px' },op.speed);
        };
        return false;
      });
    },
    // 開閉
    toggleBox:function(options){
      var defaults={
        trigger:'> dt',
        target:'> dd',
        speed:600
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $trigger=$t.find(op.trigger);
      var $target=$t.find(op.target);
      var hash=location.hash;
      var bool=true;
      if(bool){
        if($(hash).length){
          if($(hash).find(op.trigger).length&&$(hash).find(op.target).length){
            $(hash).find(op.trigger).addClass('active');
          };
        };

        if($trigger.hasClass('active')){
          $target.show();
        };

        $trigger.off('click');
        $trigger.on('click',function(){
          if($target.is(':hidden')){
            $trigger.addClass('active');
            $target.slideDown(op.speed);
          }else{
            $trigger.removeClass('active');
            $target.slideUp(op.speed);
          };
          return false;
        });
      };
    },
    // lookbookモーダル
    lookbookModal:function(options){
      var defaults={
        prefix:'blog-lookbook',
        detail:'shopify-section',
        speed:400
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $lists_item=$t.find('.lists-item');
      var $modal=$('<div class="'+op.prefix+'-modal" />');
      var $modal_content=$('<div class="'+op.prefix+'-modal__content" />');
      var $modal_detail=$('<div class="'+op.prefix+'-modal__detail" />');
      var $modal_detail_photo=$('<div class="'+op.prefix+'-modal__detail--photo" />');
      var $modal_close=$('<a class="'+op.prefix+'-modal--close" href="#">CLOSE</a>');
      var $modal_direct={
        prev:$('<a class="'+op.prefix+'-modal--direct prev" href="#">PREVIOUS</a>'),
        next:$('<a class="'+op.prefix+'-modal--direct next" href="#">NEXT</a>')
      };
      var $overlay=$('<div class="'+op.prefix+'-overlay" />');
      var index=0;
      var len=$lists_item.length;
      var st=0;
      var bool={
        modal:true,
        direct:false
      };
      var modalClose=function(){
        if(bool.modal){
          bool.modal=false;
          $modal.stop().fadeOut(op.speed,function(){
            $('body').removeClass('body-lookbook-modal');
            window.scrollTo(0,st);
            $modal_detail_photo.find('.'+op.detail).remove();
            bool.modal=true;
            bool.direct=false;
          });
        };
        return false;
      };
      var clickDirect=function(){
        $modal_detail_photo.stop().fadeOut(op.speed,function(){
          $(this).find('.'+op.detail).remove();
          bool.modal=true;
          bool.direct=true;
          $lists_item.eq(index).find('.lists-photo > a').trigger('click');
        });
      };
      var controlDirect=function(){
        if(len==1){
          $modal_direct.prev.hide();
          $modal_direct.next.hide();
        }else if(index==0){
          $modal_direct.prev.hide();
          $modal_direct.next.show();
        }else if(index==len-1){
          $modal_direct.prev.show();
          $modal_direct.next.hide();
        }else{
          $modal_direct.prev.show();
          $modal_direct.next.show();
        };
      };
      $modal_detail.append($modal_detail_photo,$modal_direct.prev,$modal_direct.next);
      $modal_content.append($modal_detail,$modal_close);
      $modal.append($modal_content,$overlay);
      $('body').append($modal);
      $lists_item.each(function(){
        var $item=$(this);
        var $photo=$item.find('.lists-photo');
        $photo.find('> a').off('click');
        $photo.find('> a').on('click',function(){
          if(bool.modal){
            bool.modal=false;
            var href=$(this).attr('href');
            index=$lists_item.index($item);
            $.ajax({
              type:'get',
              url:href,
              data:{
                type:'loookbook-ajax'
              },
              dataType:'html'
            }).done(function(data){
              var $data=$(data);
              if(!bool.direct){
                st=$(window).scrollTop();
                $('body').css({ top:'-'+st+'px' }).addClass('body-lookbook-modal');
              };
              $modal_detail_photo.append($data).stop().fadeIn(op.speed);
              $modal.stop().fadeIn(op.speed);
              controlDirect();
              bool.modal=true;
            });
          };
          return false;
        });
      });
      $modal_direct.prev.off('click');
      $modal_direct.prev.on('click',function(){
        if(bool.modal){
          bool.modal=false;
          index=index-1;
          clickDirect();
        };
        return false;
      });
      $modal_direct.next.off('click');
      $modal_direct.next.on('click',function(){
        if(bool.modal){
          bool.modal=false;
          index=index+1;
          clickDirect();
        };
        return false;
      });

      $modal_close.off('click');
      $modal_close.on('click',modalClose);
      $modal_content.off('click');
      $modal_content.on('click',modalClose);
      $modal_detail.off('click');
      $modal_detail.on('click',function(e){ e.stopPropagation(); });
    },
    // テーブルスクロール
    tableScroll:function(options){
      var defaults={
        speed:400
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var scrollMove=function(left){
        if(left>0){
          $t.addClass('scrolled');
        };
      }
      $t.on({
        'touchmove':function(e){
          var left=e.touches[0].pageX;
          scrollMove(left);
        },
        'scroll':function(e){
          var left=$t.scrollLeft();
          scrollMove(left);
        }
      });
    }
  });

  if($('.fabricguide').length){
    $('.fabricguide').find('a[href^="#"]').pageScroll();
    $('.Header__MainNav').find('a[href^="#"]').pageScroll();
  };
  if($('.page-stockists-box').length){
    $('.page-stockists-box').each(function(){
      $(this).toggleBox();
    });
  };
  if($('.blog-lookbook .lists').length){
    $('.blog-lookbook .lists').lookbookModal();
  };
  if($('.sizeguide .table').length){
    $('.sizeguide .table').each(function(){
      $(this).tableScroll();
    });
  };

// 別ページ遷移後のスムーススクロール
var urlHash = location.hash;
if (urlHash) {
  setTimeout(function() {
    // $('.PageTransition').fadeOut();
  var target = jQuery(urlHash);
  if (target.length) {
    // ページトップから開始（ブラウザ差異を考慮して併用）
    history.replaceState(null, '', window.location.pathname);
    jQuery("html,body").stop().scrollTop(0);

    jQuery(window).on("load", function () {
      var position = target.offset().top-$('#section-header').innerHeight();
      jQuery("html, body").animate({ scrollTop: position }, 400, "swing");

      // ハッシュを再設定
      // history.replaceState(null, '', window.location.pathname + urlHash);
    });
  }
  }, 300);
}
  
});

window.addEventListener('load', function() {
});